import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import DriverNav from "./DriverNav";
import "../../styles/tcDash.css";

export default function Case() {
  const authString = localStorage.getItem("user");
  const auth = authString ? JSON.parse(authString) : [];
  const [cases, setCases] = useState([]);

  useEffect(() => {
    getCases();
  }, []);

  const getCases = async () => {
    const id = auth[0].drivingLicenseNo;
    console.warn(id);
  
    try {
      const response = await fetch(`http://localhost:8000/hist/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await response.json();
      console.warn(data);
      setCases(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  

  return (
    <div>
      <header>
        <DriverNav />
      </header>
      <main>
        <div className="container mt-5 mb-4 d-flex  flex-column justify-content-center align-items-center">
          <div>
            <h3 className="mt-5 mb-4 text-white text-center">Case History</h3>
            <div className="container">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Case ID</th>
                    <th>Violation Type</th>
                    <th>Fine to pay</th>
                    <th>Case Status</th>
                    <th>Station Under</th>
                    <th>Case Added Date</th>
                    <th>Perform Operations</th>
                  </tr>
                </thead>
                <tbody>
                  {cases.map((caseItem) => (
                    <tr key={caseItem.id}>
                      <td>{caseItem.caseID}</td>
                      <td>{caseItem.violated}</td>
                      <td>{caseItem.fines}</td>
                      <td>{caseItem.status}</td>
                      <td>{caseItem.location}</td>
                      <td>{caseItem.date}</td>
                      <td>
                        <NavLink
                          className="btn btn-subtle"
                          to={"/request/update/" + caseItem.licenseNo}
                        >
                          Update Data
                        </NavLink>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
